import React, { useState } from 'react';
import SectionHeader from '../components/SectionHeader';
import { renderParagraphs } from '../utils/textFormatters';
import ProjectBanner from '../components/project/ProjectBanner';
import ToggleableDetails from '../components/ToggleableDetails';

const SpeedsilverProjectPage = ({ project, showTrivia }) => {
  const [enlargedImage, setEnlargedImage] = useState(null);
  
  // Function to handle image clicks
  const handleImageClick = (imageSrc) => {
    if (enlargedImage === imageSrc) {
      setEnlargedImage(null); // Shrink if clicked again
    } else {
      setEnlargedImage(imageSrc); // Enlarge if clicked first time
    }
  };

  return (
    <div className="project-page">
      {/* Use the ProjectBanner component instead of inline banner */}
      <ProjectBanner project={project} />
      
      <div className="max-w-5xl mx-auto p-8">
        {/* Overview Section */}
        <SectionHeader title="Overview" />
        <div className="mb-16">
          <h3 className="text-2xl font-bold mb-4 text-[#294C6F] dark:text-[#4f9cf9]">{project.titleIntro}</h3>
          <div className="text-lg text-[#333333] dark:text-white leading-relaxed">
            {/* First part of overview */}
            {project.overview1 
              ? renderParagraphs(project.overview1)
              : renderParagraphs(project.overview && project.overview.slice(0, 6))}
          </div>
          
          <h3 className="text-2xl font-bold mb-4 mt-8 text-[#294C6F] dark:text-[#4f9cf9]">What I Contributed:</h3>
          <div className="text-lg text-[#333333] dark:text-white leading-relaxed">
            {/* Second part of overview */}
            {project.overview2 
              ? renderParagraphs(project.overview2)
              : renderParagraphs(project.overview && project.overview.slice(6))}
          </div>
        </div>

        {/* SpeedSilver Events Section */}
        {project.events && (
          <div className="mb-16">
            <SectionHeader title="Event Showcase" />
            
            {/* Battle Royale 1 */}
            {project.events.battleRoyale1 && (
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-[#294C6F] dark:text-[#4f9cf9] mb-4 text-center">{project.events.battleRoyale1.title}</h3>
                
                {/* PreText - displayed before the video */}
                {project.events.battleRoyale1.preText && (
                  <div className="mb-4 text-lg text-[#333333] dark:text-white text-center">
                    {project.events.battleRoyale1.preText}
                  </div>
                )}
                
                <div className="my-6 aspect-video w-full md:w-[70%] mx-auto">
                  <iframe
                    className="w-full h-full rounded-xl"
                    src={`https://www.youtube.com/embed/${project.events.battleRoyale1.videoId}`}
                    title={project.events.battleRoyale1.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="text-lg text-[#333333] dark:text-white leading-relaxed">
                  {typeof project.events.battleRoyale1.description === 'string' 
                    ? project.events.battleRoyale1.description 
                    : renderParagraphs(project.events.battleRoyale1.description)}
                </div>
                
                {/* Toggleable Details for Legendary Weapons */}
                {project.events.battleRoyale1.implementationDetails && (
                  <ToggleableDetails 
                    title="Pedestal Details" 
                    paragraphs={project.events.battleRoyale1.implementationDetails}
                  />
                )}
                
                {/* Outro text */}
                {project.events.battleRoyale1.outro && (
                  <div className="mt-6 text-lg text-[#333333] dark:text-white leading-relaxed">
                    {renderParagraphs(project.events.battleRoyale1.outro)}
                  </div>
                )}
              </div>
            )}
            
            {/* The Purge */}
            {project.events.thePurge && (
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-[#294C6F] dark:text-[#4f9cf9] mb-4 text-center">{project.events.thePurge.title}</h3>
                
                {/* PreText - displayed before the video */}
                {project.events.thePurge.preText && (
                  <div className="mb-4 text-lg text-[#333333] dark:text-white text-center">
                    {project.events.thePurge.preText}
                  </div>
                )}
                
                <div className="my-6 aspect-video w-full md:w-[70%] mx-auto">
                  <iframe
                    className="w-full h-full rounded-xl"
                    src={`https://www.youtube.com/embed/${project.events.thePurge.videoId}`}
                    title={project.events.thePurge.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="text-lg text-[#333333] dark:text-white leading-relaxed">
                  {typeof project.events.thePurge.description === 'string' 
                    ? project.events.thePurge.description 
                    : renderParagraphs(project.events.thePurge.description)}
                </div>
                
                {/* Toggleable Details for World Events */}
                {project.events.thePurge.implementationDetails && (
                  <ToggleableDetails 
                    title="Purge World Events" 
                    paragraphs={project.events.thePurge.implementationDetails}
                  />
                )}
                
                {/* Outro text */}
                {project.events.thePurge.outro && (
                  <div className="mt-6 text-lg text-[#333333] dark:text-white leading-relaxed">
                    {renderParagraphs(project.events.thePurge.outro)}
                  </div>
                )}
              </div>
            )}
            
            {/* RPG Event */}
            {project.events.rpgEvent && (
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-[#294C6F] dark:text-[#4f9cf9] mb-4 text-center">{project.events.rpgEvent.title}</h3>
                
                {/* PreText - displayed before the video link */}
                {project.events.rpgEvent.preText && (
                  <div className="mb-4 text-lg text-[#333333] dark:text-white text-center">
                    {project.events.rpgEvent.preText}
                  </div>
                )}
                
                {/* Add RPG Overview Image */}
                <div className="my-6 w-full md:w-[70%] mx-auto">
                  <div 
                    className={`cursor-pointer transition-all duration-300 ${
                      enlargedImage === `${process.env.PUBLIC_URL}/images/rpg/rpgoverview.png` ? 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4' : ''
                    }`}
                    onClick={() => handleImageClick(`${process.env.PUBLIC_URL}/images/rpg/rpgoverview.png`)}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/images/rpg/rpgoverview.png`}
                      alt="RPG Event Overview"
                      className={`rounded-lg ${
                        enlargedImage === `${process.env.PUBLIC_URL}/images/rpg/rpgoverview.png` ? 'max-h-[90vh] max-w-[90vw] object-contain' : 'w-full h-auto'
                      }`}
                    />
                  </div>
                </div>
                
                <div className="my-4 text-center">
                  <div className="mb-6 text-center">
                    <a 
                      href={project.events.rpgEvent.videoUrl}  
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-[#2978C8] hover:text-[#294C6F] dark:text-[#4f9cf9] dark:hover:text-[#7fb5fa] transition-colors"
                    >
                      <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.615 3.184c-1.25-.5-2.5-.5-3.75-.5H8.135c-1.25 0-2.5 0-3.75.5C1.5 3.684 0 5.184 0 7.5v9c0 2.316 1.5 3.816 4.385 4.316 1.25.5 2.5.5 3.75.5h7.73c1.25 0 2.5 0 3.75-.5C22.5 20.316 24 18.816 24 16.5v-9c0-2.316-1.5-3.816-4.385-4.316zM9.545 15.537V8.463l6.001 3.037-6.001 3.037z"/>
                      </svg>
                      {project.events.rpgEvent.videoDesc}
                    </a>
                  </div>
                </div>
                
                {/* Main description */}
                <div className="text-lg text-[#333333] dark:text-white leading-relaxed">
                  {typeof project.events.rpgEvent.description === 'string' 
                    ? project.events.rpgEvent.description 
                    : renderParagraphs(project.events.rpgEvent.description)}
                </div>
                
                {/* Implementation Details */}
                {project.events.rpgEvent.implementationDetails && (
                  <ToggleableDetails 
                    title={project.events.rpgEvent.implementationDetailsTitle || "Implementation Details"} 
                    paragraphs={project.events.rpgEvent.implementationDetails}
                  />
                )}
                
                {/* Dungeons Section */}
                {project.events.rpgEvent.DungeonHeader && (
                  <div className="mt-8">
                    <h3 className="text-2xl font-bold text-[#294C6F] dark:text-[#4f9cf9] mb-4">{project.events.rpgEvent.DungeonHeader}</h3>
                    
                    {/* Dungeon Description */}
                    {project.events.rpgEvent.dungeonDescription && (
                      <div className="text-lg text-[#333333] dark:text-white leading-relaxed mb-6">
                        {renderParagraphs(project.events.rpgEvent.dungeonDescription)}
                      </div>
                    )}
                    
                    {/* Flower Dungeon */}
                    {project.events.rpgEvent.flowerDungeon && (
                      <div className="mb-8 border-b border-gray-200 dark:border-gray-700 pb-8">
                        <h4 className="text-xl font-bold text-[#294C6F] dark:text-[#4f9cf9] mb-3 text-center">
                          {project.events.rpgEvent.flowerDungeon.title}
                        </h4>
                        
                        {/* Display first image directly */}
                        {project.events.rpgEvent.flowerDungeon.images && project.events.rpgEvent.flowerDungeon.images.length > 0 && (
                          <div className="mb-4">
                            <div 
                              className={`cursor-pointer transition-all duration-300 ${
                                enlargedImage === project.events.rpgEvent.flowerDungeon.images[0] ? 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4' : ''
                              }`}
                              onClick={() => handleImageClick(project.events.rpgEvent.flowerDungeon.images[0])}
                            >
                              <img
                                src={project.events.rpgEvent.flowerDungeon.images[0]}
                                alt={`${project.events.rpgEvent.flowerDungeon.title} main image`}
                                className={`rounded-lg ${
                                  enlargedImage === project.events.rpgEvent.flowerDungeon.images[0] ? 'max-h-[90vh] max-w-[90vw] object-contain' : 'w-full md:w-2/3 mx-auto'
                                }`}
                              />
                            </div>
                          </div>
                        )}
                        
                        <div className="text-lg text-[#333333] dark:text-white leading-relaxed mb-4">
                          {renderParagraphs(project.events.rpgEvent.flowerDungeon.description)}
                        </div>
                        
                        {/* Gallery Toggle - only if there are more than 1 images */}
                        {project.events.rpgEvent.flowerDungeon.images && project.events.rpgEvent.flowerDungeon.images.length > 1 && (
                          <ToggleableDetails title="Gallery" customContent={
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                              {project.events.rpgEvent.flowerDungeon.images.slice(1).map((image, index) => (
                                <div 
                                  key={index} 
                                  className={`cursor-pointer transition-all duration-300 ${
                                    enlargedImage === image ? 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4' : ''
                                  }`}
                                  onClick={() => handleImageClick(image)}
                                >
                                  <img
                                    src={image}
                                    alt={`${project.events.rpgEvent.flowerDungeon.title} ${index + 2}`}
                                    className={`rounded-lg ${
                                      enlargedImage === image ? 'max-h-[90vh] max-w-[90vw] object-contain' : 'w-full h-auto'
                                    }`}
                                  />
                                </div>
                              ))}
                            </div>
                          } />
                        )}
                      </div>
                    )}
                    
                    {/* Ice Dungeon */}
                    {project.events.rpgEvent.IceDungeon && (
                      <div className="mb-8 border-b border-gray-200 dark:border-gray-700 pb-8">
                        <h4 className="text-xl font-bold text-[#294C6F] dark:text-[#4f9cf9] mb-3 text-center">
                          {project.events.rpgEvent.IceDungeon.title}
                        </h4>
                        
                        {/* Display first image directly */}
                        {project.events.rpgEvent.IceDungeon.images && project.events.rpgEvent.IceDungeon.images.length > 0 && (
                          <div className="mb-4">
                            <div 
                              className={`cursor-pointer transition-all duration-300 ${
                                enlargedImage === project.events.rpgEvent.IceDungeon.images[0] ? 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4' : ''
                              }`}
                              onClick={() => handleImageClick(project.events.rpgEvent.IceDungeon.images[0])}
                            >
                              <img
                                src={project.events.rpgEvent.IceDungeon.images[0]}
                                alt={`${project.events.rpgEvent.IceDungeon.title} main image`}
                                className={`rounded-lg ${
                                  enlargedImage === project.events.rpgEvent.IceDungeon.images[0] ? 'max-h-[90vh] max-w-[90vw] object-contain' : 'w-full md:w-2/3 mx-auto'
                                }`}
                              />
                            </div>
                          </div>
                        )}
                        
                        <div className="text-lg text-[#333333] dark:text-white leading-relaxed mb-4">
                          {renderParagraphs(project.events.rpgEvent.IceDungeon.description)}
                        </div>
                        
                        {/* Gallery Toggle - only if there are more than 1 images */}
                        {project.events.rpgEvent.IceDungeon.images && project.events.rpgEvent.IceDungeon.images.length > 1 && (
                          <ToggleableDetails title="Gallery" customContent={
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                              {project.events.rpgEvent.IceDungeon.images.slice(1).map((image, index) => (
                                <div 
                                  key={index} 
                                  className={`cursor-pointer transition-all duration-300 ${
                                    enlargedImage === image ? 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4' : ''
                                  }`}
                                  onClick={() => handleImageClick(image)}
                                >
                                  <img
                                    src={image}
                                    alt={`${project.events.rpgEvent.IceDungeon.title} ${index + 2}`}
                                    className={`rounded-lg ${
                                      enlargedImage === image ? 'max-h-[90vh] max-w-[90vw] object-contain' : 'w-full h-auto'
                                    }`}
                                  />
                                </div>
                              ))}
                            </div>
                          } />
                        )}
                      </div>
                    )}
                    
                    {/* Necromancer's Dungeon */}
                    {project.events.rpgEvent.NecroDungeon && (
                      <div className="mb-8">
                        <h4 className="text-xl font-bold text-[#294C6F] dark:text-[#4f9cf9] mb-3 text-center">
                          {project.events.rpgEvent.NecroDungeon.title}
                        </h4>
                        
                        {/* Display first image directly */}
                        {project.events.rpgEvent.NecroDungeon.images && project.events.rpgEvent.NecroDungeon.images.length > 0 && (
                          <div className="mb-4">
                            <div 
                              className={`cursor-pointer transition-all duration-300 ${
                                enlargedImage === project.events.rpgEvent.NecroDungeon.images[0] ? 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4' : ''
                              }`}
                              onClick={() => handleImageClick(project.events.rpgEvent.NecroDungeon.images[0])}
                            >
                              <img
                                src={project.events.rpgEvent.NecroDungeon.images[0]}
                                alt={`${project.events.rpgEvent.NecroDungeon.title} main image`}
                                className={`rounded-lg ${
                                  enlargedImage === project.events.rpgEvent.NecroDungeon.images[0] ? 'max-h-[90vh] max-w-[90vw] object-contain' : 'w-full md:w-2/3 mx-auto'
                                }`}
                              />
                            </div>
                          </div>
                        )}
                        
                        <div className="text-lg text-[#333333] dark:text-white leading-relaxed mb-4">
                          {renderParagraphs(project.events.rpgEvent.NecroDungeon.description)}
                        </div>
                        
                        {/* Gallery Toggle - only if there are more than 1 images */}
                        {project.events.rpgEvent.NecroDungeon.images && project.events.rpgEvent.NecroDungeon.images.length > 1 && (
                          <ToggleableDetails title="Gallery" customContent={
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                              {project.events.rpgEvent.NecroDungeon.images.slice(1).map((image, index) => (
                                <div 
                                  key={index} 
                                  className={`cursor-pointer transition-all duration-300 ${
                                    enlargedImage === image ? 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4' : ''
                                  }`}
                                  onClick={() => handleImageClick(image)}
                                >
                                  <img
                                    src={image}
                                    alt={`${project.events.rpgEvent.NecroDungeon.title} ${index + 2}`}
                                    className={`rounded-lg ${
                                      enlargedImage === image ? 'max-h-[90vh] max-w-[90vw] object-contain' : 'w-full h-auto'
                                    }`}
                                  />
                                </div>
                              ))}
                            </div>
                          } />
                        )}
                      </div>
                    )}
                  </div>
                )}
                
                {/* Outro text */}
                {project.events.rpgEvent.outro && (
                  <div className="mt-6 text-lg text-[#333333] dark:text-white leading-relaxed">
                    {project.events.rpgEvent.outro.length > 1 ? (
                      <>
                        {renderParagraphs(project.events.rpgEvent.outro.slice(0, -1))}
                        <p className="italic text-[#294C6F] dark:text-[#4f9cf9] font-medium">
                          {project.events.rpgEvent.outro[project.events.rpgEvent.outro.length - 1]}
                        </p>
                      </>
                    ) : (
                      <p className="italic text-[#294C6F] dark:text-[#4f9cf9] font-medium">
                        {project.events.rpgEvent.outro[0]}
                      </p>
                    )}
                  </div>
                )}
              </div>
            )}
            
            {/* Battle Royale 2-4 */}
            {project.events.battleRoyale2to4 && (
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-[#294C6F] dark:text-[#4f9cf9] mb-4 text-center">{project.events.battleRoyale2to4.title}</h3>
                
                {/* PreText - displayed before the videos */}
                {project.events.battleRoyale2to4.preText && (
                  <div className="mb-4 text-lg text-[#333333] dark:text-white text-center">
                    {project.events.battleRoyale2to4.preText}
                  </div>
                )}
                
                {project.events.battleRoyale2to4.videos && (
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-6">
                    {project.events.battleRoyale2to4.videos.map((video, vidIndex) => (
                      <div key={vidIndex} className="aspect-video">
                        <iframe
                          className="w-full h-full rounded-xl"
                          src={`https://www.youtube.com/embed/${video.videoId}`}
                          title={`${project.events.battleRoyale2to4.title} Video ${vidIndex + 1}`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    ))}
                  </div>
                )}
                <div className="text-lg text-[#333333] dark:text-white leading-relaxed">
                  {typeof project.events.battleRoyale2to4.description === 'string' 
                    ? project.events.battleRoyale2to4.description 
                    : renderParagraphs(project.events.battleRoyale2to4.description)}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Bedrock Pack Section */}
        {project.events.bedrockPack && (
          <div className="mb-16">
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-[#294C6F] dark:text-[#4f9cf9] mb-4 text-center">{project.events.bedrockPack.title}</h3>
              
              {/* PreText */}
              {project.events.bedrockPack.pretext && (
                <div className="mb-6 text-lg text-[#333333] dark:text-white text-center">
                  {project.events.bedrockPack.pretext}
                </div>
              )}
              
              {/* Image */}
              {project.events.bedrockPack.image && (
                <div className="my-6 w-full md:w-[70%] mx-auto">
                  <img 
                    src={project.events.bedrockPack.image} 
                    alt={project.events.bedrockPack.title}
                    className="w-full h-auto rounded-xl shadow-md"
                  />
                </div>
              )}
              
              {/* Marketplace Link with Arrow Icon */}
              {project.events.bedrockPack.link && (
                <div className="my-6 text-center">
                  <a 
                    href={project.events.bedrockPack.link}  
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-[#2978C8] hover:text-[#294C6F] dark:text-[#4f9cf9] dark:hover:text-[#7fb5fa] transition-colors"
                  >
                    <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                    {project.events.bedrockPack.linkText || "View on Minecraft Marketplace"}
                  </a>
                </div>
              )}
              
              {/* Description */}
              <div className="text-lg text-[#333333] dark:text-white leading-relaxed">
                {typeof project.events.bedrockPack.description === 'string' 
                  ? project.events.bedrockPack.description 
                  : renderParagraphs(project.events.bedrockPack.description)}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SpeedsilverProjectPage; 